import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-approved-checkmark.tsx
/**
* icon.24.approved.checkmark
*
* Keywords: check, verification, confirmation, validation, complete, correct, success
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyIDVhNyA3IDAgMSAxIDAgMTQgNyA3IDAgMCAxIDAtMTRtMCAxYTYgNiAwIDEgMCAwIDEyIDYgNiAwIDAgMCAwLTEybTIuNTY4IDIuNzQ4YS41LjUgMCAxIDEgLjg2NC41MDRsLTMuNSA2YS41LjUgMCAwIDEtLjc4Ni4xMDFsLTMtM2EuNS41IDAgMSAxIC43MDgtLjcwN2wyLjU0IDIuNTQxeiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1258
*/
const Icon24ApprovedCheckmark = memo(function Icon24ApprovedCheckmark(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 1a6 6 0 1 0 0 12 6 6 0 0 0 0-12m2.568 2.748a.5.5 0 1 1 .864.504l-3.5 6a.5.5 0 0 1-.786.101l-3-3a.5.5 0 1 1 .708-.707l2.54 2.541z"
		})
	});
});
//#endregion
export { Icon24ApprovedCheckmark };

//# sourceMappingURL=icon-24-approved-checkmark.js.map